export const YEAR_MONTH_SELECT_DROPDOWN_MAX_HEIGHT = 296
